import { BookOpen } from 'lucide-react'
import { Button } from '~/components/common/Button'
import { Typography } from '~/components/common/Typography'
import { CloseIcon, Modal, ModalBody, ModalFooter } from '~/components/modals/CurieModal'

export interface ViewInAnyPointStudioModalProps {
  isOpen: boolean
  onClose: () => void
}

export function ViewInAnyPointStudioModal({ isOpen, onClose }: ViewInAnyPointStudioModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} hideCloseButton className='w-[612px]'>
      <div
        className='flex items-center justify-between border-b border-tokens-neutral-border-2 pl-6 select-none'
        data-testid='view-in-anypoint-studio-header'
      >
        <div className='flex h-9 min-w-0 flex-1 items-center gap-4'>
          <div className='flex size-8 shrink-0 items-center justify-center rounded-full p-2 text-tokens-neutral-text-primary'>
            <BookOpen className='size-[18px]' />
          </div>
          <Typography
            fontFamily='geist'
            fontSize='titleSm'
            fontWeight='bold'
            className='text-tokens-neutral-text-primary'
          >
            View in Anypoint Studio
          </Typography>
        </div>
        <button
          type='button'
          onClick={onClose}
          aria-label='Close modal'
          className='flex items-center justify-center p-5 text-tokens-neutral-icon-default hover:bg-tokens-neutral-fill-fill-6 transition-colors'
        >
          <CloseIcon className='size-6' />
        </button>
      </div>

      <ModalBody>
        <div className='flex flex-col gap-4 text-tokens-neutral-text-primary'>
          <Typography fontFamily='geist' fontSize='bodyMdMedium' fontWeight='medium'>
            To open this MuleSoft project in Anypoint Studio
          </Typography>
          <ol className='list-decimal pl-6'>
            <li>
              <Typography fontFamily='geist' fontSize='bodyMdMedium' fontWeight='medium'>
                <span className='font-bold'>Download</span> the project zip using the button above.
              </Typography>
            </li>
            <li>
              <Typography fontFamily='geist' fontSize='bodyMdMedium' fontWeight='medium'>
                Unzip it to your Studio workspace folder.
              </Typography>
            </li>
            <li>
              <Typography fontFamily='geist' fontSize='bodyMdMedium' fontWeight='medium'>
                In Anypoint Studio, go to File → Import → Anypoint Studio project from File System,
                select the unzipped folder, and click Finish.
              </Typography>
            </li>
            <li>
              <Typography fontFamily='geist' fontSize='bodyMdMedium' fontWeight='medium'>
                Wait for Maven to resolve dependencies.
              </Typography>
            </li>
          </ol>
          <Typography fontFamily='geist' fontSize='bodyMdMedium' fontWeight='medium'>
            What to look at:
          </Typography>
          <ul className='list-disc pl-6'>
            <li>
              <Typography fontFamily='geist' fontSize='bodyMdMedium' fontWeight='medium'>
                src/main/mule/ — flow XML files (open in the visual canvas)
              </Typography>
            </li>
            <li>
              <Typography fontFamily='geist' fontSize='bodyMdMedium' fontWeight='medium'>
                src/main/resources/ — configs and DataWeave scripts
              </Typography>
            </li>
            <li>
              <Typography fontFamily='geist' fontSize='bodyMdMedium' fontWeight='medium'>
                pom.xml — runtime version and dependencies
              </Typography>
            </li>
          </ul>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button
          variant='outlined'
          onClick={onClose}
          className='h-9 px-4 text-tokens-neutral-bg-action'
        >
          <Typography fontFamily='geist' fontSize='bodyMdMedium' fontWeight='medium'>
            Close
          </Typography>
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ViewInAnyPointStudioModal
